import { Export } from "@fusion-advantage/backcompat"
import { CalcScriptCompileError, CalcScriptExecutableCreator, CalcType, ExecutableCalc } from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { selectForm } from "../../redux/selectForm"
import { createCollaboratorNameValueCalc, createCollaboratorNotesValidationCalc, createCollaboratorSignatureValidationCalc, createEvaluatorSignatureValidationCalc } from "./EvaluatorSignatureCalc"
import { createDiagnosisReviewValidationCalc } from "./AssessmentCalc"
import { createLabFollowUpPcpValueCalc, createLabValidationCalc } from "./LabCalc"
import { createOncologyValidationCalc } from "./OncologyCalc"
import { createNeurologicWeaknessValidationCalc } from "./NeurologicHumanoidCalc"
import { createDefaultValidationCalcs } from "./DefaultValidationCalc"
import { createNotTakingMedsValueCalc, createPrescriptionActivationCalc, createPrescriptionValidationCalc } from "./PrescriptionCalc"
import { createUlcerFollowUpPcpValueCalc, createUlcerValidationCalc } from "./UlcerCalc"
import { createDefaultValueCalcs } from "./DefaultValueCalc"
import { createPcpValidationCalc } from "./PcpCalc"

export const createCalcs = (exp: Export): FormThunk<ExecutableCalc[]> => (dispatch, getState) => {
	const calcs: ExecutableCalc[] = []
	calcs.push(createEvaluatorSignatureValidationCalc())
	calcs.push(createCollaboratorNotesValidationCalc())
	calcs.push(createCollaboratorSignatureValidationCalc())
	calcs.push(createCollaboratorNameValueCalc())
	calcs.push(createDiagnosisReviewValidationCalc(getState))
	calcs.push(createLabValidationCalc(getState))
	calcs.push(createLabFollowUpPcpValueCalc(getState, exp))
	calcs.push(createPcpValidationCalc())
	calcs.push(createPrescriptionValidationCalc(getState))
	calcs.push(createOncologyValidationCalc(getState))
	calcs.push(createUlcerValidationCalc(getState))
	calcs.push(createUlcerFollowUpPcpValueCalc(getState))
	calcs.push(createNeurologicWeaknessValidationCalc(getState))
	calcs.push(createNotTakingMedsValueCalc(getState))
	calcs.push(createPrescriptionActivationCalc(getState))
	const [flowmapCalcs, compileErr] = createFlowmapScriptCalculations(getState, exp)
	calcs.push(...flowmapCalcs)
	if(compileErr.length > 0) {
		// TODO dispatch properly
		console.error('[formrender createCalcs]', compileErr)
		alert(`Logged to console: [formrender createCalcs] ${JSON.stringify(compileErr)}`)
	}
	const activationCalcs = calcs.filter((c) => c.calcType === CalcType.Activation)
	calcs.push(...createDefaultValueCalcs(activationCalcs))
	calcs.push(...createDefaultValidationCalcs(getState))
	return calcs
}

// a.k.a. "form supported calculations"
const createFlowmapScriptCalculations = (getState: () => FormRootState, exp: Export): [ExecutableCalc[], CalcScriptCompileError[]] => {
	const compileErr: CalcScriptCompileError[] = []
	const scriptExCreator = new CalcScriptExecutableCreator()
	const designator = exp.Form.Encounter.BranchDesignatorV2
	const calcs: ExecutableCalc[] = []
	const calcScripts = selectForm(getState()).calcScripts
	for(let script of calcScripts) {
		if(script.designators && !script.designators.includes(designator)) {
			// does not apply to form with this designator;
			// this is a backup check to the flow compiler which now filters
			// relevant calculations according to the branchDesignator attr
			// on the root <XFlow /> node
			continue
		}
		let rCreate = scriptExCreator.createFromFormCalcScript(script)
		if(rCreate.isErr()) {
			// TODO dispatch properly
			compileErr.push({
				...rCreate.error,
				area: `[createFlowmapScriptCalculations '${script.outputCid}'] ` + rCreate.error.area
			})
			continue
		}
		calcs.push(rCreate.value)
	}
	return [calcs, compileErr]
}
